/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdgangAccessControl } from './AdgangAccessControl';
import {
    AdgangAccessControlFromJSON,
    AdgangAccessControlFromJSONTyped,
    AdgangAccessControlToJSON,
    AdgangAccessControlToJSONTyped,
} from './AdgangAccessControl';
import type { OrganizationResponse } from './OrganizationResponse';
import {
    OrganizationResponseFromJSON,
    OrganizationResponseFromJSONTyped,
    OrganizationResponseToJSON,
    OrganizationResponseToJSONTyped,
} from './OrganizationResponse';
import type { AccessRequestStatus } from './AccessRequestStatus';
import {
    AccessRequestStatusFromJSON,
    AccessRequestStatusFromJSONTyped,
    AccessRequestStatusToJSON,
    AccessRequestStatusToJSONTyped,
} from './AccessRequestStatus';
import type { UserKrrResponse } from './UserKrrResponse';
import {
    UserKrrResponseFromJSON,
    UserKrrResponseFromJSONTyped,
    UserKrrResponseToJSON,
    UserKrrResponseToJSONTyped,
} from './UserKrrResponse';
import type { AltinnResponse } from './AltinnResponse';
import {
    AltinnResponseFromJSON,
    AltinnResponseFromJSONTyped,
    AltinnResponseToJSON,
    AltinnResponseToJSONTyped,
} from './AltinnResponse';
import type { AccessExpirationResponse } from './AccessExpirationResponse';
import {
    AccessExpirationResponseFromJSON,
    AccessExpirationResponseFromJSONTyped,
    AccessExpirationResponseToJSON,
    AccessExpirationResponseToJSONTyped,
} from './AccessExpirationResponse';
import type { UserType } from './UserType';
import {
    UserTypeFromJSON,
    UserTypeFromJSONTyped,
    UserTypeToJSON,
    UserTypeToJSONTyped,
} from './UserType';

/**
 * 
 * @export
 * @interface AccessRequestResponse
 */
export interface AccessRequestResponse {
    /**
     * 
     * @type {any}
     * @memberof AccessRequestResponse
     */
    accessReqeuestId?: any | null;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestResponse
     */
    applicationId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestResponse
     */
    applicationName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestResponse
     */
    applicationDescription?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof AccessRequestResponse
     */
    createdOn?: Date;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestResponse
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestResponse
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestResponse
     */
    employer?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestResponse
     */
    finalNote?: string | null;
    /**
     * 
     * @type {AccessRequestStatus}
     * @memberof AccessRequestResponse
     */
    status?: AccessRequestStatus;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestResponse
     */
    telefonNr?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AccessRequestResponse
     */
    isChangedByProcessingUser?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof AccessRequestResponse
     */
    modifiedOn?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestResponse
     */
    processedByUserId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestResponse
     */
    receiptCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestResponse
     */
    requestedByUserId?: string | null;
    /**
     * 
     * @type {UserType}
     * @memberof AccessRequestResponse
     */
    requestedByUserType?: UserType;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestResponse
     */
    requestedByUserName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestResponse
     */
    requestedByUserSectionName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AccessRequestResponse
     */
    isRequestedByUserIdPortenVerified?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestResponse
     */
    requestedByUserMfaPhone?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AccessRequestResponse
     */
    isUnlocksExternalApproverRightsRequest?: boolean;
    /**
     * 
     * @type {any}
     * @memberof AccessRequestResponse
     */
    requestedRoleId?: any | null;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestResponse
     */
    requestedRoleName?: string | null;
    /**
     * 
     * @type {any}
     * @memberof AccessRequestResponse
     */
    assignedRoleId?: any | null;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestResponse
     */
    assignedRoleName?: string | null;
    /**
     * 
     * @type {any}
     * @memberof AccessRequestResponse
     */
    requestedPermissionId?: any | null;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestResponse
     */
    requestedPermissionName?: string | null;
    /**
     * 
     * @type {any}
     * @memberof AccessRequestResponse
     */
    assignedPermissionId?: any | null;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestResponse
     */
    assignedPermissionName?: string | null;
    /**
     * 
     * @type {any}
     * @memberof AccessRequestResponse
     */
    organizationId?: any | null;
    /**
     * 
     * @type {boolean}
     * @memberof AccessRequestResponse
     */
    isEmployerVerified?: boolean;
    /**
     * 
     * @type {OrganizationResponse}
     * @memberof AccessRequestResponse
     */
    organization?: OrganizationResponse;
    /**
     * 
     * @type {AltinnResponse}
     * @memberof AccessRequestResponse
     */
    altinn?: AltinnResponse;
    /**
     * 
     * @type {UserKrrResponse}
     * @memberof AccessRequestResponse
     */
    userKrr?: UserKrrResponse;
    /**
     * 
     * @type {any}
     * @memberof AccessRequestResponse
     */
    accessExpirationId?: any | null;
    /**
     * 
     * @type {AccessExpirationResponse}
     * @memberof AccessRequestResponse
     */
    accessExpiration?: AccessExpirationResponse;
    /**
     * 
     * @type {Array<AdgangAccessControl>}
     * @memberof AccessRequestResponse
     */
    accessControls?: Array<AdgangAccessControl> | null;
}



/**
 * Check if a given object implements the AccessRequestResponse interface.
 */
export function instanceOfAccessRequestResponse(value: object): value is AccessRequestResponse {
    return true;
}

export function AccessRequestResponseFromJSON(json: any): AccessRequestResponse {
    return AccessRequestResponseFromJSONTyped(json, false);
}

export function AccessRequestResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessRequestResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'accessReqeuestId': json['accessReqeuestId'] === undefined ? undefined : json['accessReqeuestId'] === null ? null : json['accessReqeuestId'],
        'applicationId': json['applicationId'] === undefined ? undefined : json['applicationId'] === null ? null : json['applicationId'],
        'applicationName': json['applicationName'] === undefined ? undefined : json['applicationName'] === null ? null : json['applicationName'],
        'applicationDescription': json['applicationDescription'] === undefined ? undefined : json['applicationDescription'] === null ? null : json['applicationDescription'],
        'createdOn': json['createdOn'] == null ? undefined : (new Date(json['createdOn'])),
        'description': json['description'] === undefined ? undefined : json['description'] === null ? null : json['description'],
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : json['email'],
        'employer': json['employer'] === undefined ? undefined : json['employer'] === null ? null : json['employer'],
        'finalNote': json['finalNote'] === undefined ? undefined : json['finalNote'] === null ? null : json['finalNote'],
        'status': json['status'] == null ? undefined : AccessRequestStatusFromJSON(json['status']),
        'telefonNr': json['telefonNr'] === undefined ? undefined : json['telefonNr'] === null ? null : json['telefonNr'],
        'isChangedByProcessingUser': json['isChangedByProcessingUser'] == null ? undefined : json['isChangedByProcessingUser'],
        'modifiedOn': json['modifiedOn'] === undefined ? undefined : json['modifiedOn'] === null ? null : (new Date(json['modifiedOn'])),
        'processedByUserId': json['processedByUserId'] === undefined ? undefined : json['processedByUserId'] === null ? null : json['processedByUserId'],
        'receiptCode': json['receiptCode'] === undefined ? undefined : json['receiptCode'] === null ? null : json['receiptCode'],
        'requestedByUserId': json['requestedByUserId'] === undefined ? undefined : json['requestedByUserId'] === null ? null : json['requestedByUserId'],
        'requestedByUserType': json['requestedByUserType'] == null ? undefined : UserTypeFromJSON(json['requestedByUserType']),
        'requestedByUserName': json['requestedByUserName'] === undefined ? undefined : json['requestedByUserName'] === null ? null : json['requestedByUserName'],
        'requestedByUserSectionName': json['requestedByUserSectionName'] === undefined ? undefined : json['requestedByUserSectionName'] === null ? null : json['requestedByUserSectionName'],
        'isRequestedByUserIdPortenVerified': json['isRequestedByUserIdPortenVerified'] == null ? undefined : json['isRequestedByUserIdPortenVerified'],
        'requestedByUserMfaPhone': json['requestedByUserMfaPhone'] === undefined ? undefined : json['requestedByUserMfaPhone'] === null ? null : json['requestedByUserMfaPhone'],
        'isUnlocksExternalApproverRightsRequest': json['isUnlocksExternalApproverRightsRequest'] == null ? undefined : json['isUnlocksExternalApproverRightsRequest'],
        'requestedRoleId': json['requestedRoleId'] === undefined ? undefined : json['requestedRoleId'] === null ? null : json['requestedRoleId'],
        'requestedRoleName': json['requestedRoleName'] === undefined ? undefined : json['requestedRoleName'] === null ? null : json['requestedRoleName'],
        'assignedRoleId': json['assignedRoleId'] === undefined ? undefined : json['assignedRoleId'] === null ? null : json['assignedRoleId'],
        'assignedRoleName': json['assignedRoleName'] === undefined ? undefined : json['assignedRoleName'] === null ? null : json['assignedRoleName'],
        'requestedPermissionId': json['requestedPermissionId'] === undefined ? undefined : json['requestedPermissionId'] === null ? null : json['requestedPermissionId'],
        'requestedPermissionName': json['requestedPermissionName'] === undefined ? undefined : json['requestedPermissionName'] === null ? null : json['requestedPermissionName'],
        'assignedPermissionId': json['assignedPermissionId'] === undefined ? undefined : json['assignedPermissionId'] === null ? null : json['assignedPermissionId'],
        'assignedPermissionName': json['assignedPermissionName'] === undefined ? undefined : json['assignedPermissionName'] === null ? null : json['assignedPermissionName'],
        'organizationId': json['organizationId'] === undefined ? undefined : json['organizationId'] === null ? null : json['organizationId'],
        'isEmployerVerified': json['isEmployerVerified'] == null ? undefined : json['isEmployerVerified'],
        'organization': json['organization'] == null ? undefined : OrganizationResponseFromJSON(json['organization']),
        'altinn': json['altinn'] == null ? undefined : AltinnResponseFromJSON(json['altinn']),
        'userKrr': json['userKrr'] == null ? undefined : UserKrrResponseFromJSON(json['userKrr']),
        'accessExpirationId': json['accessExpirationId'] === undefined ? undefined : json['accessExpirationId'] === null ? null : json['accessExpirationId'],
        'accessExpiration': json['accessExpiration'] == null ? undefined : AccessExpirationResponseFromJSON(json['accessExpiration']),
        'accessControls': json['accessControls'] === undefined ? undefined : json['accessControls'] === null ? null : ((json['accessControls'] as Array<any>).map(AdgangAccessControlFromJSON)),
    };
}

export function AccessRequestResponseToJSON(json: any): AccessRequestResponse {
    return AccessRequestResponseToJSONTyped(json, false);
}

export function AccessRequestResponseToJSONTyped(value?: AccessRequestResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accessReqeuestId': value['accessReqeuestId'],
        'applicationId': value['applicationId'],
        'applicationName': value['applicationName'],
        'applicationDescription': value['applicationDescription'],
        'createdOn': value['createdOn'] == null ? value['createdOn'] : value['createdOn'].toISOString(),
        'description': value['description'],
        'email': value['email'],
        'employer': value['employer'],
        'finalNote': value['finalNote'],
        'status': AccessRequestStatusToJSON(value['status']),
        'telefonNr': value['telefonNr'],
        'isChangedByProcessingUser': value['isChangedByProcessingUser'],
        'modifiedOn': value['modifiedOn'] == null ? value['modifiedOn'] : value['modifiedOn'].toISOString(),
        'processedByUserId': value['processedByUserId'],
        'receiptCode': value['receiptCode'],
        'requestedByUserId': value['requestedByUserId'],
        'requestedByUserType': UserTypeToJSON(value['requestedByUserType']),
        'requestedByUserName': value['requestedByUserName'],
        'requestedByUserSectionName': value['requestedByUserSectionName'],
        'isRequestedByUserIdPortenVerified': value['isRequestedByUserIdPortenVerified'],
        'requestedByUserMfaPhone': value['requestedByUserMfaPhone'],
        'isUnlocksExternalApproverRightsRequest': value['isUnlocksExternalApproverRightsRequest'],
        'requestedRoleId': value['requestedRoleId'],
        'requestedRoleName': value['requestedRoleName'],
        'assignedRoleId': value['assignedRoleId'],
        'assignedRoleName': value['assignedRoleName'],
        'requestedPermissionId': value['requestedPermissionId'],
        'requestedPermissionName': value['requestedPermissionName'],
        'assignedPermissionId': value['assignedPermissionId'],
        'assignedPermissionName': value['assignedPermissionName'],
        'organizationId': value['organizationId'],
        'isEmployerVerified': value['isEmployerVerified'],
        'organization': OrganizationResponseToJSON(value['organization']),
        'altinn': AltinnResponseToJSON(value['altinn']),
        'userKrr': UserKrrResponseToJSON(value['userKrr']),
        'accessExpirationId': value['accessExpirationId'],
        'accessExpiration': AccessExpirationResponseToJSON(value['accessExpiration']),
        'accessControls': value['accessControls'] == null ? undefined : ((value['accessControls'] as Array<any>).map(AdgangAccessControlToJSON)),
    };
}

